import http from '@/utils/request'
import defaultSettings from '@/settings'

// 直接通过覆盖的方式

/**
 * 获取验证码
 * @param data 查询条件
 */
export function getVerifyCode(id) {
  return http.request({
    url: 'Captcha',
    method: 'get',
    params: { id: id },
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}
/**
 * 获取token
 * @param query
 */
export function getUserToken(query) {
  var data = {
    'grant_type': 'client_credential',
    'appid': defaultSettings.appId,
    'secret': defaultSettings.appSecret
  }
  return http({
    url: 'Token',
    method: 'get',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 *刷新token
 * @param {*} data
 */
export function refreshToken(data) {
  return http({
    url: 'Token/RefreshToken',
    method: 'get',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
 * 获取系统基础设置信息(未登录返回的信息)
 */
export function getBaseInfo() {
  return http({
    url: 'SysSetting/GetBaseInfo',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取系统基础设置信息(完整的系统配置信息)
 */
export function getAllInfo() {
  return http({
    url: 'SysSetting/GetAllInfo',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
 * 保存系统配置
 */
export function saveSysSetting(data) {
  return http({
    url: 'SysSetting/Save',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取所有子系统
 */
export function getSubSystemList() {
  return http({
    url: 'SystemType/GetSubSystemList',
    method: 'get',
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
 * 系统切换
 * @param ids id集合
 */
export function scmConnecSys(data) {
  return http({
    url: 'SystemType/ScmConnecSys',
    method: 'get',
    params: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
 * 清除系统缓存
 * @param ids id集合
 */
export function clearSystemCahce() {
  return http({
    url: 'SystemType/ClearSystemCahce',
    method: 'get',
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
 * 保存修改密码
 * @param data 密码
 * @returns
 */
export function savePassword(data) {
  var query = data
  return http({
    url: 'User/ModifyPassword',
    method: 'post',
    params: query,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
 * 清除缓存
 * @returns
 */
export function clearCache() {
  return http({
    url: 'User/ClearCache',
    method: 'get',
    baseURL: defaultSettings.apiSecurityUrl
  })
}



/**
 * 登录
 * @param {*} data
 */
export async function login(data) {
  var query = data
  return http({
    url: 'Login/WebManagerLogin',
    method: 'post',
    data: data,
    timeout: 0,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取用户授权信息
 * @returns
 */
export async function getAuthInfo() {
  return http({
    url: 'Login/GetAuthInfo',
    method: 'get',
    timeout: 0,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取用户个人信息
 * @returns
 */
export async function GetProfile() {
  return http({
    url: 'Login/GetProfile',
    method: 'get',
    timeout: 0,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 退出登录
 */
export function logout() {
  return http({
    url: 'Login/Logout',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 系统切换sso
 * @param ids id集合
 */
export function sysConnect(data) {
  return http({
    url: 'Login/SysConnect',
    method: 'get',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}


/**
 * 获取微信小程序二维码
 * @param data 查询条件
 */
export function getWxAppletQrCode(data) {
  return http.request({
    url: 'WeiXin/WxOpen/ContentWxAppletQrCode',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}

/**
 * 初始化子系统
 */
export async function initSystem() {
  return http({
    url: 'Dashboard/InitSystem',
    method: 'get',
    timeout: 0,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取系统桌面需要返回的信息
 */
export async function getDashboardInfo() {
  return http({
    url: 'Dashboard/GetDashboardInfo',
    method: 'get',
    timeout: 0,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 首页看板数据
 * @returns
 */
export function getIndex() {
  return http.request({
    url: 'Dashboard/GetIndex',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
* 核销订单
*/
export function scanConfirmOrder(data) {
  return http.request({
    url: 'Validity/scanConfirmOrder',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
* 核销订单
*/
export function getBillLadingInfo(data) {
  return http.request({
    url: 'Validity/GetBillLadingInfo',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}



/**
 * 获取应用参数配置
 * @param data 查询条件
 */
export function getSysOptions() {
  return http.request({
    url: 'Config/GetSysOptions',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}
/**
 * 获取应用参数配置
 * @param data 查询条件
 */
export function getTravelOptions() {
  return http.request({
    url: 'Config/GetTravelOptions',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}
/**
* 根据参数获取相关参数需要的所有地区
*/
export function getMapTreeTable(data) {
  return http.request({
    url: 'Config/GetMapTreeTable',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}
/**
 * 获取应用参数配置
 * @param data 查询条件
 */
export function getGoodAdditionOptions() {
  return http.request({
    url: 'Config/GetGoodAdditionOptions',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}
/**
 * 获取应用参数配置
 * @param data 查询条件
 */
export function getTourAdditionOptions() {
  return http.request({
    url: 'Config/GetTourAdditionOptions',
    method: 'get',
    baseURL: defaultSettings.apiHostUrl// 直接通过覆盖的方式
  })
}
/**
* 根据参数获取通用枚举列表(单个)
*/
export function getCommEnumType(data) {
  return http.request({
    url: 'Config/GetCommEnumType',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
* 根据参数获取通用枚举列表（多个）
*/
export function getCommEnumTypeList(data) {
  return http.request({
    url: 'Config/GetCommEnumTypeList',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
* 根据参数获取Good枚举列表(单个)
*/
export function getGoodEnumType(data) {
  return http.request({
    url: 'Config/GetGoodEnumType',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
* 根据参数获取Good枚举列表（多个）
*/
export function getGoodEnumTypeList(data) {
  return http.request({
    url: 'Config/GetGoodEnumTypeList',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}


/**
* 根据参数获取Tour枚举列表(单个)
*/
export function getTourEnumType(data) {
  return http.request({
    url: 'Config/GetTourEnumType',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiHostUrl
  })
}

/**
* 根据参数获取Tour枚举列表（多个）
*/
export function getTourEnumTypeList(data) {
  return http.request({
    url: 'Config/GetTourEnumTypeList',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiHostUrl
  })
}